import i18n from 'i18next'; import React, { useEffect, useState } from 'react';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { siteOptions } from '../../constants';

const WarningDialog = () => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    const siteOptionsObj = JSON.parse(localStorage.getItem(siteOptions) || '{}');
    siteOptionsObj.doNotShowWarninDialog = true;
    localStorage.setItem(siteOptions, JSON.stringify(siteOptionsObj));
    setOpen(false);
  };

  useEffect(() => {

    // let siteOptionsObj = localStorage.getItem(siteOptions);
    // if (siteOptionsObj) {
    //   siteOptionsObj = JSON.parse(siteOptionsObj);
    //   if (!siteOptionsObj?.doNotShowWarninDialog || siteOptionsObj?.doNotShowWarninDialog !== true) {
    //     setOpen(true);
    //   }
    // } else {
    //   setOpen(true);
    // }
  }, []); return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      className="tp-how-new-order__modal"
    >
      <DialogTitle>
        <Box sx={{ display: 'flex',
          flexFlow: 'row nowrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%'
        }}
        >

          <b>{i18n.t('WarningDialog.\xF6nemli_uyar\u0131')}</b>
          <IconButton
            aria-label={i18n.t('WarningDialog.close')}
            onClick={handleClose}
          >

            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Typography>
          <p><b>{i18n.t('WarningDialog.say\u0131n_m\xFC\u015Fterimiz')}</b></p>
          <p>
            <strong>{i18n.t('WarningDialog.joobid_com')}</strong>
            {' '}
            {i18n.t('WarningDialog.ve')}

            {' '}
            <strong>{i18n.t('WarningDialog.musteri_joobid_com')}</strong>
            {' '}
            {i18n.t('WarningDialog.adresi_d\u0131\u015F\u0131nda_resmi_bir_web_sitesi_bulu')}

            <strong>{i18n.t('WarningDialog.joobid_com')}</strong>
            {' '}
            {i18n.t('WarningDialog.ve')}

            {' '}
            <strong>{i18n.t('WarningDialog.musteri_joobid_com')}</strong>
            {' '}
            {i18n.t('WarningDialog.adresi_hari\xE7_herhangi_bir_web_sitesi_lin')}

          </p>
          <p>{i18n.t('WarningDialog.sayg\u0131lar\u0131m\u0131zla')}</p>
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default WarningDialog;
